import { createStyles, MenuItem, MenuList, Paper, TextField, Theme, Typography, withStyles } from "@material-ui/core";
import * as React from "react";
import { LocationSummary } from "../../domain/auxilary/LocationSummary";
import locationsDataService from "../../services/site/LocationDataService";

import i18n from "../../services/localization/i18n";

const styles = (theme: Theme) => createStyles({
    noResults: {
        padding: theme.spacing(),
        paddingLeft: theme.spacing(),
    },
    results: {
        maxWidth: 600,
    },
    root: {
        display: "flex",
        flexDirection: "column",
        marginLeft: theme.spacing(),
    },
    textField: {
        flexGrow: 1,
    },
});

interface ICityPickerState {
    open: boolean;
    locations?: LocationSummary[];
    selectedLocation?: LocationSummary;
    value: string;
    width: number;
    fullWidth: boolean;
}

interface ICityPickerProps {
    autoFocus?: boolean;
    fullWidth?: boolean;
    label: string;
    location?: LocationSummary;
    margin: "none" | "dense" | "normal";
    variant: "outlined" | "filled" | "standard";
    classes?: {
        noResults: any;
        root: any;
        results: any;
        textField: any;
    };

    onSelect: (location?: LocationSummary)  => void;
    width?: number;
}

class CityPicker extends React.Component<ICityPickerProps, ICityPickerState> {

    /**
     * Creates an instance of CityPicker.
     * @param {ICityPickerProps} props
     * @memberof CityPicker
     */
    constructor(props: ICityPickerProps) {
        super(props);

        this.state = {
            fullWidth: !!props.fullWidth,
            open: false,
            selectedLocation: props.location,
            value: this.getLocationLabel(props.location),
            width: props.width || 240,
        };
    }

    public render() {
        const {classes} = this.props;
        const {margin} = this.props;
        const {variant} = this.props;
        const {autoFocus} = this.props;
        const {width} = this.props;

        return  <div className={classes!.root}>
            <TextField
                autoFocus={autoFocus}
                autoComplete="off"
                id="city"
                label={ i18n.t("citypicker_label") }
                className={classes!.textField}
                value={this.state.value}
                onChange={this.onLocationChanged}
                onKeyDown={this.onKeyDown}
                margin={margin}
                variant={variant as any}
                style={{
                    width,
                }}
            />

            {this.state.open && this.state.locations && this.showSearchResults()}
        </div>;
    }

    private onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (!this.state.open) {
            if (e.keyCode === 40) {
                this.setState({
                    open: true,
                });
            }
            return;
        }

        if (!this.state.locations) {
            return;
        }

        if (e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) {
            return;
        }

        if (e.keyCode === 13) {
            this.onMenuItemSelected(this.state.selectedLocation);
        }

        let currentIndex  = 0;
        if (this.state.selectedLocation) {
            currentIndex = this.state.locations.findIndex((p) => p.id === this.state.selectedLocation!.id);

            if (e.keyCode === 38) {
                // keyup
                if (currentIndex > 0) {
                    currentIndex--;
                } else {
                    currentIndex = this.state.locations.length - 1;
                }
            } else if (e.keyCode === 40) {
                // keydown
                if (currentIndex <  this.state.locations.length - 1) {
                    currentIndex++;
                } else {
                    currentIndex = 0;
                }
            }
        }

        this.setState({
            selectedLocation: this.state.locations[currentIndex],
        });
    }

    private showSearchResults = () => {
        const {classes} = this.props;

        return <Paper square={true} className={classes!.results}>
                {this.state.locations!.length === 0 &&
                    <Typography className={classes!.noResults}>
                        { i18n.t("citypicker_nomatch") }
                    </Typography>
                }
                {this.state.locations!.length > 0 &&
                    <MenuList>
                        {this.state.locations!.map((match, idx) =>
                            <MenuItem   selected={this.state.selectedLocation === match}
                                        // tslint:disable-next-line: jsx-no-lambda
                                        onClick={() => this.onMenuItemSelected(match)}
                                        key={idx}>
                                    {this.getLocationLabel(match)}
                            </MenuItem>,
                        )}
                    </MenuList>
                }
        </Paper>;
    }

    private onMenuItemSelected = (locationInfo?: LocationSummary) => {
        this.setState({
            open: false,
            selectedLocation: locationInfo,
            value: this.getLocationLabel(locationInfo),
        });

        this.props.onSelect(locationInfo);
    }

    private onLocationChanged = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        this.setState({
            value: e.target.value,
        });

        locationsDataService.searchAsync(e.target.value)
            .then((locations) => {
                this.setState({
                    locations,
                    open: true,
                    selectedLocation: locations.length > 0 ? locations[0] : undefined,
                });
            });
    }

    private getLocationLabel = (location?: LocationSummary): string =>  {

        if (!location)  {
            return "";
        }

        return location.title || "";
    }

}

export default withStyles(styles)(CityPicker);
